'use client'

import { useIsMobileDevice } from '@/hooks/use-screen'
import { useKeepFocusedFieldVisible } from '@/hooks/use-visual-viewport'

/** Touch devices: keeps the focused field on screen when the keyboard opens. */
export function MobileKeyboardSync() {
  useKeepFocusedFieldVisible(useIsMobileDevice())
  return null
}
